import React from "react";
import { FileText } from "lucide-react";

const MyTransactions = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-6 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-12 text-center">
          <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <FileText className="w-8 h-8 text-slate-400" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Feature Removed</h1>
          <p className="text-slate-600">
            Transaction history has been removed from the system.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MyTransactions;
